import { combineReducers } from 'redux';
import project, { committedProjectSlice } from './project/projectslice';
/* import template from './template/templateSlice';*/
import results from './project/resultsSlice';

export default combineReducers({
  /*   template, */
    committedProject: committedProjectSlice.reducer,
    project,
    results
});
